// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { TreeTokens } from './type';

const treeTokens: TreeTokens = {
  treeFontSize: 'Font-14',
  treeFontWeight: 'Weight-regular',
  treeFontColor: 'Neutral-text-5',
  treeLineHeight: 'Size-18',
  treeLineBackgroundColor: 'Neutral-fill-3',
  treeSmallFontSize: 'Font-12',
  treeSmallLineHeight: 'Size-14',
  treeLargeFontSize: 'Font-16',
  treeLargeLineHeight: 'Size-22',
  treePaddingX: 'Spacing-8',
  treePaddingY: 'Spacing-1',
  treeItemFontColor: 'Neutral-text-4',
  treeItemHoverBackgroundColor: 'Neutral-fill-2',
  treeItemHoverFontColor: 'Neutral-text-4',
  treeItemActiveBackgroundColor: 'Neutral-fill-4',
  treeItemActiveFontColor: 'Neutral-text-4',
  treeItemDisabledFontColor: 'Neutral-text-2',
  treeContentHoverBackgroundColor: 'Neutral-fill-2',
  treeContentHoverFontColor: 'Neutral-text-5',
  treeContentActiveBackgroundColor: 'Brand-1',
  treeContentActiveFontColor: 'Brand-6',
  treeContentActiveBorderRadius: 'Radius-lesser',
  treeContentDisabledBackgroundColor: 'Transprent',
  treeContentDisabledFontColor: 'Neutral-text-5',
  treeContentBorderRadius: 'Radius-lesser',
  treeDragBorderColor: 'Brand-6',
  treeDragBackgroundColor: 'Brand-1',
  treeTextPaddingY: 'Spacing-2',
  treeTextPaddingX: 'Spacing-4',
  treeCheckboxMarginX: 'Spacing-8',
  treeIconSize: 'Font-14',
};

export default treeTokens;
